import { useLayoutEffect } from 'react';
import { scrollToTop } from '../utils/scrollToTop';

/** Scroll to top when a single dependency changes (e.g. dashboard section). */
export function useScrollToTop(dep) {
  useLayoutEffect(() => {
    scrollToTop();
  }, [dep]);
}

/** Scroll to top when any of the given dependencies change. */
export function useScrollToTopWhen(dep1, dep2) {
  useLayoutEffect(() => {
    scrollToTop();
  }, [dep1, dep2]);
}
